// admin.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard implements CanActivate {

  private readonly ADMIN_STATE = '$2a$12$yT69u8ypn7hMRuBLhLrju.9K.oKv0dYQWSbES4LCEOi5VaWt3r5D';

  constructor(private router: Router) {}

  canActivate(): boolean {
    const state = localStorage.getItem('state');

    if (state === this.ADMIN_STATE) {
      // Allow access
      return true;
    } else {
      // Redirect to main page
      this.router.navigateByUrl('/');
      return false;
    }
  }
}
